import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthLayout } from '../catalyst/auth-layout';
import { Button } from '../catalyst/button';
import { Input } from '../catalyst/input';
import { Heading } from '../catalyst/heading';
import { Text } from '../catalyst/text';
import { useAuth } from '../contexts/AuthContext';
import { supabase } from '../lib/supabase';

export default function LoginPage() {
	const { session, loading } = useAuth();
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [error, setError] = useState<string | null>(null);
	const [submitting, setSubmitting] = useState(false);

	if (loading) {
		return (
			<div className="flex h-screen items-center justify-center">
				<div className="text-zinc-500">Loading...</div>
			</div>
		);
	}

	if (session) {
		return <Navigate to="/" replace />;
	}

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setError(null);
		setSubmitting(true);

		const { error: authError } = await supabase.auth.signInWithPassword({
			email,
			password,
		});

		if (authError) {
			setError(authError.message);
		}
		setSubmitting(false);
	};

	return (
		<AuthLayout>
			<div className="w-full max-w-sm">
				<div className="flex flex-col items-center mb-8">
					<img src="/logo_dark.webp" alt="Melonpost" className="h-16 w-auto object-contain mb-4" />
					<Heading level={1}>Melonpost Admin</Heading>
				</div>

				<Text className="mb-6">Sign in to the admin dashboard.</Text>

				{error && (
					<div className="mb-4 rounded-lg bg-red-50 p-3 text-sm text-red-700 dark:bg-red-900/20 dark:text-red-400">
						{error}
					</div>
				)}

				<form onSubmit={handleSubmit} className="space-y-4">
					<div>
						<label className="mb-1 block text-sm font-medium text-zinc-700 dark:text-zinc-300">
							Email
						</label>
						<Input
							type="email"
							value={email}
							onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
							required
							autoFocus
						/>
					</div>

					<div>
						<label className="mb-1 block text-sm font-medium text-zinc-700 dark:text-zinc-300">
							Password
						</label>
						<Input
							type="password"
							value={password}
							onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
							required
						/>
					</div>

					<Button type="submit" color="emerald" className="w-full" disabled={submitting}>
						{submitting ? 'Signing in...' : 'Sign in'}
					</Button>
				</form>
			</div>
		</AuthLayout>
	);
}
